import { FC } from "react";
import classes from './studentItem.module.scss'

interface IProps {
    count: number;
}

export const CommentsCount: FC<IProps> = ({count}) => {


    return (
        <section className={classes.commentsCount}>
            <svg width="24" height="24" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M9.675 25.2375L5.6375 28.6125C5.49181 28.7331 5.31493 28.8098 5.12737 28.8339C4.93981 28.858 4.74927 28.8284 4.57784 28.7486C4.40642 28.6688 4.26114 28.542 4.15886 28.3829C4.05658 28.2239 4.0015 28.0391 4 27.85V8C4 7.73478 4.10536 7.48043 4.29289 7.29289C4.48043 7.10536 4.73478 7 5 7H27C27.2652 7 27.5196 7.10536 27.7071 7.29289C27.8946 7.48043 28 7.73478 28 8V24C28 24.2652 27.8946 24.5196 27.7071 24.7071C27.5196 24.8946 27.2652 25 27 25H10.3125C10.0784 25.0001 9.85209 25.0844 9.675 25.2375V25.2375Z" stroke="black" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M16 17.5C16.8284 17.5 17.5 16.8284 17.5 16C17.5 15.1716 16.8284 14.5 16 14.5C15.1716 14.5 14.5 15.1716 14.5 16C14.5 16.8284 15.1716 17.5 16 17.5Z" fill="black"/>
                <path d="M10 17.5C10.8284 17.5 11.5 16.8284 11.5 16C11.5 15.1716 10.8284 14.5 10 14.5C9.17157 14.5 8.5 15.1716 8.5 16C8.5 16.8284 9.17157 17.5 10 17.5Z" fill="black"/>
                <path d="M22 17.5C22.8284 17.5 23.5 16.8284 23.5 16C23.5 15.1716 22.8284 14.5 22 14.5C21.1716 14.5 20.5 15.1716 20.5 16C20.5 16.8284 21.1716 17.5 22 17.5Z" fill="black"/>
            </svg>
            {count}
        </section>
    )
}